<template>
  <div id="cpx_quotient_deal">
    <div class="flex">
      <div class="flex1 pr-20">
        <el-form :model="cpx_info" label-width="120px">
          <p class="title">基本信息</p>
          <el-form-item label="商单标题:">{{cpx_info.cpx_order_name}}</el-form-item>
          <el-form-item label="报名截止时间:">{{cpx_info.sign_up_time?cpx_info.sign_up_time.slice(0,10):''}}</el-form-item>
          <el-form-item label="预计推广时间:">
            {{cpx_info.expect_begin_time ? cpx_info.expect_begin_time.slice(0,10):''}}至
            {{cpx_info.expect_end_time ? cpx_info.expect_end_time.slice(0,10):''}}
          </el-form-item>
        </el-form>
        <el-form label-position="top" :model="cpx_info">
          <p class="title">客户信息&十问</p>
          <el-form-item label="1、客户品牌:">
            {{cpx_info.cpx_brand_name}}
          </el-form-item>
          <el-form-item label="2、客户来源:">
            <span v-if="cpx_info.cpx_client_source == 1">品牌方</span>
            <span v-if="cpx_info.cpx_client_source == 2">TP代运营</span>
            <span v-if="cpx_info.cpx_client_source == 3">垂直代理</span>
            <span v-if="cpx_info.cpx_client_source == 4">广告公司</span>
            <span v-if="cpx_info.cpx_client_source == 5">短视频营销整合公司</span>
            <span v-if="cpx_info.cpx_client_source == 6">其他</span>
          </el-form-item>
          <el-form-item label="3、投放落地到哪里:">
            <span class="sd-tag" v-if="cpx_info.cpx_client_target_location_tb==2">淘宝</span>
            <span class="sd-tag" v-if="cpx_info.cpx_client_target_location_tm==2">天猫</span>
            <span class="sd-tag" v-if="cpx_info.cpx_client_target_location_jd==2">京东自营</span>
            <span class="sd-tag" v-if="cpx_info.cpx_client_target_location_jdpop==2">京东pop</span>
            <span class="sd-tag" v-if="cpx_info.cpx_client_target_location_other==2">其他（{{cpx_info.cpx_client_target_location_other_name}}）</span>
          </el-form-item>
          <el-form-item label="4、全年GMV有多少，或问线上线下GMV占比多少？">
            GMV: {{cpx_info.cpx_client_yearly_GMV}}
            <div>
              线上占比：{{cpx_info.cpx_client_yearly_GMV_online}}%
              线下占比：{{cpx_info.cpx_client_yearly_GMV_offline}}%
            </div>
          </el-form-item>
          <el-form-item label="5、线上部分，天猫和京东的占比情况如何，分别怎么进行推广投放的？">
            {{cpx_info.cpx_client_oneline_push_remark}}
          </el-form-item>
          <el-form-item label="6、电商平台是怎么做的？">
            <div class="pre">{{cpx_info.cpx_client_platform_push_remark}}</div>
          </el-form-item>
          <el-form-item label="7、品牌找我们合作目的：GMV？ROI利润？品宣？">
            <div>
              第一选择：
              <span v-if="cpx_info.cpx_client_purpose_p == 1">GMV</span>
              <span v-if="cpx_info.cpx_client_purpose_p == 2">ROI（利润）</span>
              <span v-if="cpx_info.cpx_client_purpose_p == 3">品宣</span>
            </div>
            <div>
              第二选择：
              <span v-if="cpx_info.cpx_client_purpose_s == 1">GMV</span>
              <span v-if="cpx_info.cpx_client_purpose_s == 2">ROI（利润）</span>
              <span v-if="cpx_info.cpx_client_purpose_s == 3">品宣</span>
            </div>
          </el-form-item>
          <el-form-item label="8、样品管够吗，怎么发；佣金怎么开（定向/通用/营销、基础佣金够不够能不能挂上抖音快手）；坑位费给多少，以及开佣金改价格的对应负责人是谁？">
            <div>
              <span v-if="cpx_info.cpx_client_sample == 1">是，管够</span>
              <span v-if="cpx_info.cpx_client_sample == 2">否，限量 {{cpx_info.cpx_client_sample_num}}个</span>
              <span v-if="cpx_info.cpx_client_sample == 3">无</span>
            </div>
            <div>
              佣金方式：
              <span class="sd-tag" v-if="cpx_info.cpx_client_commission_target==2">定向</span>
              <span class="sd-tag" v-if="cpx_info.cpx_client_commission_general==2">通用</span>
              <span class="sd-tag" v-if="cpx_info.cpx_client_commission_sale==2">营销</span>
              <span class="sd-tag" v-if="cpx_info.cpx_client_commission_other==2">其他（{{cpx_info.cpx_client_commission_other_name}}）</span>
            </div>
            <div>推广预算：￥{{cpx_info.budget_money}}</div>
            <div>
              佣金、价格负责人：{{cpx_info.cpx_client_commission_contact_name}}&nbsp;&nbsp;&nbsp;&nbsp;联系方式：{{cpx_info.cpx_client_commission_contact}}
            </div>
          </el-form-item>
          <el-form-item label="9、合同签好了吗？什么时候签，怎么签？是否已下发邮件？是否属于垫款池内客户">
            <div class="pre">{{cpx_info.cpx_client_contraction_remark}}</div>
          </el-form-item>
          <el-form-item label="10、如果品牌特定达人，是否接受单次翻车可能">
            <div class="pre">{{cpx_info.cpx_client_other_remark}}</div>
          </el-form-item>
        </el-form>
      </div>
      <div class="flex1 pl-20">
        <el-form :model="cpx_info" label-width="120px">
          <p class="title">本次合作计划</p>
          <el-form-item label="合作模式:">
            <span v-if="cpx_info.cps==2" class="mr-5">CPS</span>
            <span v-if="cpx_info.cpt_recommended==2" class="mr-5">CPT种草</span>
            <span v-if="cpx_info.cpt_goods==2" class="mr-5">CPT带货</span> 
            <span v-if="cpx_info.cpa==2" class="mr-5">CPA</span> 
            <span v-if="cpx_info.cpc==2" class="mr-5">CPC</span> 
          </el-form-item>
          <el-form-item label="推广形式:">
            <span v-if="cpx_info.promote_video==2" class="mr-5">短视频</span>
            <span v-if="cpx_info.promote_live==2" class="mr-5">直播混播</span>
            <span v-if="cpx_info.promote_live_special==2" class="mr-5">直播专场</span> 
            <span v-if="cpx_info.promote_other==2" class="mr-5">其他(图文等)</span> 
          </el-form-item>
          <el-form-item label="预估账期:">{{cpx_info.expect_payment}}</el-form-item>
          <el-form-item label="结算方式:">{{cpx_info.settlement_source==1?'联盟（星任务/京任务）':'非联盟（合同等）'}}</el-form-item>
          <el-form-item label="推广预算:">{{cpx_info.budget_money}}元</el-form-item>
        </el-form>
        <el-form :model="cpx_info" label-width="120px">
          <p class="title">项目负责人</p>
          <el-form-item label="佣金价格负责人:">{{cpx_info.cpx_client_commission_contact_name}}</el-form-item>
          <el-form-item label="项目负责人:">{{cpx_info.cpx_project_adid_name}}</el-form-item>
          <el-form-item label="项目运营负责人:">{{cpx_info.order_project_adid_name}}</el-form-item>
          <el-form-item label="项目媒介负责人:">{{cpx_info.cpx_project_kol_adid_name}}</el-form-item>
          <el-form-item label="项目其他干系人:">
            <div v-for="(item,inx) in cpx_info.cpx_order_other" :key="inx">
              {{item.project_adid_name}}（{{item.project_name}}）
            </div>
          </el-form-item>
        </el-form>
        <el-form :model="cpx_info" label-width="120px">
          <p class="title">其他信息</p>
          <el-form-item label="brief:">
            <div class="p-flex-just-betwn">
              <el-link :underline="false" type="primary" target="_blank" :href="cpx_info.brief_file" v-if="cpx_info.brief_name">{{cpx_info.brief_name}}</el-link>
            </div>
          </el-form-item>
          <el-form-item label="排期表:">
            <div class="p-flex-just-betwn">
              <el-link :underline="false" type="primary" target="_blank" :href="cpx_info.schedule_file">{{cpx_info.schedule_name}}</el-link>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import utils from "@/utils/util.js";

export default {
  name: "cpx_quotient_deal",
  props: {
    cxorid: ""
  },
  data() {
    return {
      // user_info: {},
      cpx_info: {},
      loadBeloon: false,
      apiUrl: {
        cpxOrderInfo: "/home/cpxOrderInfo" // CPX商单广场 详情
      }
    };
  },
  computed: {
    disabled() {
      return this.loadBeloon;
    }
  },
  created() {
    this.getData(1, 1);
  },
  mounted() {
    // this.user_info = utils.getAuth("user_info") || {};
  },
  methods: {
    //初始化数据
    getData() {
      let _this = this;
      _this
        .$http({
          method: "POST",
          url: _this.apiUrl.cpxOrderInfo,
          data: { cxorid: _this.cxorid }
        })
        .then(res => {
          if (res.code == 1 && res.data) {
            if(res.data.cpx_brand_name.indexOf('其他品牌、') !=-1){
              res.data.cpx_brand_name = res.data.cpx_brand_name.replace("其他品牌、","其他品牌(") + ")"
            }
            _this.cpx_info = res.data;
            _this.cpx_info.order_imgs = _this.cpx_info.order_imgs.split(',')
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
  }
};
</script>
<style scoped>
.flex{
  display: flex;
  justify-content: space-between;
}
.flex1{
  flex: 1;
}
.pr-20{
  padding-right: 20px;
}
.pl-20{
  padding-left: 20px;
}
.title{
  font-size: 20px;
  color: #252328;
  margin-bottom: 20px;
  position: relative;
}
.title::before{
  content: "";
  position: absolute;
  width: 3px;
  height: 20px;
  background-color: #6435E8;
  left: -20px;
  top: 4px;
}
.pre{
  white-space: pre-wrap;
}
.mr-5{
  margin-right: 5px;
}
.p-flex-just-betwn{
  display: flex;
  display: -webkit-flex;
  display: -moz-flex;
  align-items: center;
  justify-content: space-between;
}
#cpx_quotient_deal >>> .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
  margin-bottom: 0;
}
#cpx_quotient_deal >>> .el-form--label-top .el-form-item__label{
  padding-bottom: 0;
  color: #666;
}
#cpx_quotient_deal >>> .el-form-item__content{
  color: #666;
}
</style>